import { isLoadedDefined } from "common/components/component-helpers";
import { ClickableStyle, LabelStyle } from "../../styled-components";
import {
    PotentialValue,
    ActionSource,
    RenderEnvironment,
    Context,
    asMaybeAction,
} from "common/components/types";
import { OnClickHandler } from "hooks/use-on-click-from-action";

export const Clickable = ClickableStyle;

export const Label = LabelStyle;

export function makeOnClickFromAction(
    onTap: PotentialValue,
    source: ActionSource,
    ctx: Context,
    env: RenderEnvironment
): { onClick: OnClickHandler; targetURL: string | undefined; autoRunInTabletMode: boolean } {
    if (!isLoadedDefined(onTap)) return { onClick: undefined, targetURL: undefined, autoRunInTabletMode: false };

    const action = asMaybeAction(onTap);
    if (action === undefined) return { onClick: undefined, targetURL: undefined, autoRunInTabletMode: false };

    const onClick = (handled: boolean | undefined) => action.run(ctx, env, source, handled);
    const targetURL = action.targetURL(ctx, env, source);

    // We don't want to auto-push in the builder, however, because if we did
    // we couldn't tell whether the app creator wants to edit the detail
    // screen or the list screen.  This ##autoRunInTabletMode flag here is
    // used by item renderers to decide whether they should auto-run their
    // actions if they're the first item.

    return { onClick, targetURL, autoRunInTabletMode: !env.appEnvironment.isBuilder && action.autoRunInTabletMode };
}
